export default __webpack_public_path__ + "static/media/logo-pt.8fc6cea0.svg";